import * as Roles from '@/store/roles';

export const companyActionsPermissions = {
  addCompany: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  mailCompanyRegistrationLink: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  mailCompanyMissingFilesReminder: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  addCompanyRegistrationLink: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  addSyncedCompany: [Roles.Any],
  deleteCompany: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  fetchCompanies: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  getDefaultCompany: [Roles.Any],
  saveCompanyProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  setCompanyProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  syncCompanyProperties: [Roles.Any],
  updateStateCompanies: [Roles.Any],
};



// WEBPACK FOOTER //
// ./src/store/company/companyActionsPermissions.js